export var mapperDataTypes=["gw-rest-object"];